import React from 'react';
import {
    InputAdornment,
    Dialog,
    DialogContent,
    Button,
    FormControl,
    Card,
    CardContent,
    CircularProgress,
    TextField,
} from '@material-ui/core';

import Alert from '@material-ui/lab/Alert';

import MailOutlineTwoToneIcon from '@material-ui/icons/MailOutlineTwoTone';
import MobileOutlineTwoToneIcon from '@material-ui/icons/MobileScreenShareOutlined';
import DoneIcon from '@material-ui/icons/Done';

import { withStyles } from '@material-ui/core/styles';
import CloseButton from '../close_button';

const StyledCard = withStyles(theme => ({
    root: {
        margin: 'auto',
        maxWidth: '500px',
        minWidth: "312px"
    }
}))(props => <Card elevation={0} className="card-box mb-4" {...props} />);

const OTPLinks = (props) =>
    <div className="text-right">
        <Button onClick={props.onOTPResend}
            className="font-size-lg p-0 pl-3" color="primary">
            Resend ({props.otpResendAttemps})
        </Button>
    </div>

export default function OPTModal(props) {

    const onSigninClick = () => {
        if (props.onSigninClick && typeof props.onSigninClick === "function") {
            props.onSigninClick();
        }
    }

    return (
        <Dialog
            disableBackdropClick
            disableEscapeKeyDown
            open={props.open}
            maxWidth="lg"
            scroll={"paper"}
            onClose={props.onClose}>
            <DialogContent className="p-0">
                <CloseButton onClose={props.onClose} />
                <StyledCard>
                    <div className="card-header">
                        <div className="card-header--title py-2 font-size-lg 
                            font-weight-bold text-center">
                            Verify Email and Mobile OTP
                       </div>
                    </div>
                    <CardContent className="p-3">
                        {props.mobileOtpVerified && props.emailOtpVerified &&
                            <div className="mb-3">
                                <Alert severity="info">
                                    Redirecting to sign in page in 5 seconds ....
                            </Alert>
                            </div>
                        }
                        <Alert severity="info">
                            We have sent an OTP on email address and mobile number,
                            enter same in respective fields and verify. If you didn't get
                            an OTP yet please wait for few seconds or click on resend link.
                        </Alert>
                        <div className={`mt-3 ${props.showEmailOtpBox ? "" : 'd-none'}`}>
                            <FormControl className="w-100">
                                <TextField
                                    autoComplete="off"
                                    error={props.emailOTPError ? true : false}
                                    helperText={props.emailOTPError}
                                    fullWidth
                                    disabled={props.emailOtpProcessing || props.emailOtpVerified}
                                    label="Email OTP"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <MailOutlineTwoToneIcon />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            props.emailOtpProcessing ?
                                                <InputAdornment position="end">
                                                    <CircularProgress style={{ width: "25px", height: "25px" }} />
                                                </InputAdornment>
                                                :
                                                props.emailOtpVerified ?
                                                    <InputAdornment position="end">
                                                        <DoneIcon htmlColor="green" />
                                                    </InputAdornment>
                                                    : null
                                        )
                                    }}

                                    value={props.emailOTP}
                                    onChange={(e) => { props.setEmailOTP(e.target.value.trim()) }}
                                />


                                {!props.emailOtpVerified &&
                                    <OTPLinks onOTPVerify={props.onEmailOTPVerify}
                                        onOTPResend={props.onEmailOTPResend}
                                        otpResendAttemps={props.emailOTPResendAttemps}
                                    />
                                }
                            </FormControl>
                        </div>
                        <div className={`${props.showEmailOtpBox ? "mb-3" : 'my-3'}`}>
                            <FormControl className="w-100">
                                <TextField
                                    error={props.mobileOTPError ? true : false}
                                    helperText={props.mobileOTPError}
                                    fullWidth
                                    autoComplete="off"
                                    label="Mobile OTP"
                                    disabled={props.mobileOtpProcessing || props.mobileOtpVerified}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <MobileOutlineTwoToneIcon />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            props.mobileOtpProcessing ?
                                                <InputAdornment position="end">
                                                    <CircularProgress style={{ width: "25px", height: "25px" }} />
                                                </InputAdornment>
                                                :
                                                props.mobileOtpVerified ?
                                                    <InputAdornment position="end">
                                                        <DoneIcon htmlColor="green" />
                                                    </InputAdornment>
                                                    : null
                                        )
                                    }}

                                    value={props.mobileOTP}
                                    onChange={(e) => { props.setMobileOTP(e.target.value.trim()) }}
                                />

                                {!props.mobileOtpVerified &&
                                    <OTPLinks onOTPVerify={props.onMobileOTPVerify}
                                        onOTPResend={props.onMobileOTPResend}
                                        otpResendAttemps={props.mobileOTPResendAttemps}
                                    />
                                }
                            </FormControl>
                        </div>
                        <div className="text-center">
                            <Button color="primary"
                                className="m-2 text-primary px-0"
                                onClick={props.onOTPVerify}>
                                <span>Verify</span>
                            </Button>
                        </div>
                    </CardContent>
                </StyledCard>
            </DialogContent>
        </Dialog>
    );
}